import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ConnectedDotsIcon: React.FC<SvgIconProps> = (
  props: SvgIconProps
) => {
  return (
    <SvgIcon
      {...props}
      width="52"
      height="12"
      viewBox="0 0 52 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.2835 8.83272e-06C44.1075 -0.000282809 42.9572 0.345056 41.9758 0.993102C40.9944 1.64115 40.2251 2.56332 39.7635 3.645H31.1535C30.6903 2.56712 29.9212 1.64869 28.9415 1.00335C27.9617 0.357998 26.8142 0.0140474 25.641 0.0140474C24.4678 0.0140474 23.3203 0.357998 22.3406 1.00335C21.3608 1.64869 20.5917 2.56712 20.1285 3.645H11.5185C10.9758 2.37331 10.0106 1.32807 8.78603 0.68606C7.56148 0.0440447 6.15277 -0.155344 4.79814 0.121613C3.44352 0.39857 2.22611 1.13488 1.35182 2.20601C0.477526 3.27714 0 4.61735 0 6C0 7.38265 0.477526 8.72286 1.35182 9.79399C2.22611 10.8651 3.44352 11.6014 4.79814 11.8784C6.15277 12.1553 7.56148 11.956 8.78603 11.3139C10.0106 10.6719 10.9758 9.62669 11.5185 8.355H20.1285C20.5917 9.43288 21.3608 10.3513 22.3406 10.9967C23.3203 11.642 24.4678 11.986 25.641 11.986C26.8142 11.986 27.9617 11.642 28.9415 10.9967C29.9212 10.3513 30.6903 9.43288 31.1535 8.355H39.7635C40.1889 9.35178 40.8763 10.2147 41.7527 10.8522C42.6292 11.4897 43.6619 11.8779 44.7413 11.9756C45.8206 12.0732 46.9063 11.8768 47.8829 11.407C48.8595 10.9372 49.6907 10.2117 50.2881 9.30743C50.8855 8.4032 51.2269 7.35405 51.2759 6.2714C51.3249 5.18876 51.0798 4.11305 50.5665 3.15853C50.0533 2.20401 49.2911 1.40633 48.3609 0.850202C47.4307 0.294077 46.3673 0.000277613 45.2835 8.83272e-06Z"
        fill="#56C9F1"
      />
    </SvgIcon>
  )
}
